import { render, staticRenderFns } from "./OverviewTab.vue?vue&type=template&id=47171934&scoped=true"
import script from "./OverviewTab.vue?vue&type=script&lang=ts"
export * from "./OverviewTab.vue?vue&type=script&lang=ts"
import style0 from "./OverviewTab.vue?vue&type=style&index=0&id=47171934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47171934",
  null
  
)

export default component.exports